import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import FilterByMonthYear from "../../Filters/FilterByMonthYear";
import RateHistoryTable from "./OfferTables/RateHistoryTable";
import OfferApplicationTable from "./OfferTables/OfferApplicationTable";
import TextButton from "../../../../application/components/Button/TextButton";
import OfferInterviewTable from "./OfferTables/OfferInterviewTable";
import OfferOnOfferTable from "./OfferTables/OfferOnOfferTable";
import OfferCredentialTable from "./OfferTables/OfferCredentialTable";
import OfferBackgroundTable from "./OfferTables/OfferBackgroundTable";
import OfferPolicyTable from "./OfferTables/OfferPolicyTable";
import OfferOrientationTable from "./OfferTables/OfferOrientationTable";
import OfferEvaluationTable from "./OfferTables/OfferEvaluationTable";
import OfferTrainingTable from "./OfferTables/OfferTrainingTable";
import OfferMiscellaneousTable from "./OfferTables/OfferMiscellaneousTable";
import OfferTerminationTable from "./OfferTables/OfferTerminationTable";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OfferTabs() {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="flex mt-8 mb-8">
      <Box sx={{ width: "100%" }}>
        <Divider />
        <Box sx={{}}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons={true}
            sx={{
              "& .MuiTabs-flexContainer": {
                [theme.breakpoints.only("xs")]: {
                  flexWrap: "wrap",
                },
              },
            }}
          >
            <Tab
              label="Rate History"
              {...a11yProps(0)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Application"
              {...a11yProps(1)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Interview"
              {...a11yProps(2)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />

            <Tab
              label="Offer"
              {...a11yProps(3)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />

            <Tab
              label="Credentials"
              {...a11yProps(4)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />

            <Tab
              label="Background"
              {...a11yProps(5)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Policy & Agreement"
              {...a11yProps(6)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Orientation Topics"
              {...a11yProps(7)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Evaluation"
              {...a11yProps(8)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Quarterly Trainings"
              {...a11yProps(9)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />
            <Tab
              label="Miscellaneous"
              {...a11yProps(10)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
            <Divider
              orientation="vertical"
              style={{
                height: "24px",
                marginTop: "12px",
                marginBottom: "12px",
              }}
            />

            <Tab
              label="Termination"
              {...a11yProps(11)}
              style={{
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                paddingTop: "16px",
              }}
              iconPosition="end"
            />
          </Tabs>
        </Box>

        <section className="flex justify-end mt-[30.5px] mb-[24px]  pr-4">
          {value === 0 ? (
            <FilterByMonthYear />
          ) : (
            <div>
              <TextButton
                className="text-[#1E87FF]"
                text={
                  value === 4 || value === 7 || value === 8 || value === 9
                    ? "+ Send File"
                    : "+ Add File"
                }
                color="#1E87FF"
              />
            </div>
          )}
        </section>
        <CustomTabPanel value={value} index={0}>
          <RateHistoryTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <OfferApplicationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <OfferInterviewTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          <OfferOnOfferTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={8}>
          <OfferCredentialTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={10}>
          <OfferBackgroundTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={12}>
          <OfferPolicyTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={14}>
          <OfferOrientationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={16}>
          <OfferEvaluationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={18}>
          <OfferTrainingTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={20}>
          <OfferMiscellaneousTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={22}>
          <OfferTerminationTable />
        </CustomTabPanel>
      </Box>
    </div>
  );
}
